import React from 'react';
import {
  CContainer,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CCardHeader,
  CBreadcrumb,
  CBreadcrumbItem,
} from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import StockInputs from '../../components/StockStatusInputs/StockStatusInputs';
import { connect } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import {
  createStockStatusRequestAction,
} from '../../store/stockStatus/stockStatusActions';

const CreateStockStatus = (props) => {
  const {
    createStockStatusRequest,
    isLoading,
    createStockStatusData,
  } = props;

  const navigate = useNavigate();
  const { t } = useTranslation();

  // Form submit handler
  const handleStockSubmit = (stockStatusData) => {
    console.log('Submitting stock:', stockStatusData);
    createStockStatusRequest({
      data: stockStatusData,
      navigate: navigate
    });
  };

  // Back to stock page
  const handleBackToStock = () => {
    navigate('/stock-status');
  };

  return (
    <div>
      <CContainer>
        {/* Breadcrumb */}
        <CBreadcrumb className="mb-4">
          <CBreadcrumbItem 
            href="#/stock-status" 
            onClick={(e) => {
              e.preventDefault();
              handleBackToStock();
            }}
          >
            {t('Stock')}
          </CBreadcrumbItem>
          <CBreadcrumbItem active>{t('createNewStock')}</CBreadcrumbItem>
        </CBreadcrumb>

        <CRow>
          <CCol xs={12}>
            <CCard>
              <CCardHeader>
                <h4 className="mb-0">{t('createNewStock')}</h4>
              </CCardHeader>
              <CCardBody>
                <StockInputs 
                  onSubmit={handleStockSubmit}
                  onCancel={handleBackToStock}
                  isLoading={isLoading}
                  submitResponse={createStockStatusData}
                />
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.loadingReducer?.isLoading || false,
    createStockStatusData: state.stockStatusReducer?.createStockStatusData || null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createStockStatusRequest: (payload) => {
      dispatch(createStockStatusRequestAction(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateStockStatus);
